import React from 'react';
import PropTypes from 'prop-types';
import InputField from './InputField';
import validateUrl from '../../lib/UrlValidator';

export default class ImageField extends React.Component {
  constructor(props) {
    super(props);
    this.onInput = this.onInput.bind(this);
  }

  static propTypes = {
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    onInput: PropTypes.func,
    value: function (props, propName, componentName) {
      let property = props[propName];
      if (typeof(property) !== 'object' || !property.hasOwnProperty('url')) {
        return new Error(
          `Invalid prop ${propName} supplied to ${componentName}. Validation failed.`
        );
      }
    },
  };

  static defaultProps = {
    required: false
  };

  onInput(name, value, error) {
    let image = this.props.value;
    image.url = value;

    (this.props.onInput && this.props.onInput(name, image, error)); // eslint-disable-line no-unused-expressions
  }

  render() {
    let imageUrl = this.props.value.url;
    let imageView = (imageUrl) ? <img src={imageUrl} role="presentation"/> : null;
    let {onInput, value, ...rest} = this.props; // eslint-disable-line no-unused-vars

    return (
      <div className="controlled-image-field image-field">
        <InputField validator={validateUrl}
                    {...rest}
                    onInput={this.onInput}
                    required={this.props.required}
                    value={imageUrl}
        />
        {imageView}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/FieldComponents/ImageField.jsx
 **/